import { render } from "./SideNav.vue?vue&type=template&id=28e03e15"
import script from "./SideNav.vue?vue&type=script&lang=ts"
export * from "./SideNav.vue?vue&type=script&lang=ts"

import "./SideNav.vue?vue&type=style&index=0&id=28e03e15&lang=scss"
script.render = render

export default script